"use client";

import BaseProductPage from "../../shared/product/base-product-page";
import StoreBox from "../store-box";
import ProductDetails from "./product-details";
import styles from "./index.module.css";
import SimilarProducts from "./similarProducts";
import ProductPageSkeleton from "./product-page-skeleton";

const ProductPage = (props) => (
  <BaseProductPage
    {...props}
    StoreBox={StoreBox}
    ProductDetails={ProductDetails}
    SimilarProducts={SimilarProducts}
    ProductPageSkeleton={ProductPageSkeleton}
    styles={styles}
    productBreadcrumbClassName={styles.defaultProductBreadcrumb}
  />
);

export default ProductPage;
